import React from 'react';
import { Text, Link } from '@perch-labs/shrike';
import { copyFor } from 'config';

const getCopy = copyFor('login');

export const Footer = () => (
  <Text textAlign="center">
    {getCopy('footer')}
    <Link href={import.meta.env.ARCADIA_FUNNEL_URL}>
      {getCopy('links.signUp')}
    </Link>
  </Text>
);
